import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ToastrService } from 'ngx-toastr';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { BehaviorSubject, Subject } from 'rxjs';
import { RegionService } from './region.service';
@Component({
  selector: 'app-region',
  templateUrl: './region.component.html',
  styleUrls: ['./region.component.scss']
})
export class RegionComponent implements OnInit {
  bucketurl = environment.bucketUrl;
  displayedColumns: string[] = ['SNo', 'region_name', 'region_code' ,'state', 'zone', 'country', 'status', 'action'];
  public ELEMENT_DATA: any = [];
  dataSource = new MatTableDataSource(this.ELEMENT_DATA);

  @ViewChild(MatSort, { static: true })
  sort: MatSort = new MatSort;
  @ViewChild(MatPaginator, { static: true })
  paginator!: MatPaginator;
  regionForm: FormGroup;
  isLoading: Subject<boolean> = new Subject<boolean>();
  public searchInput = new FormControl("");

  constructor(private toastr: ToastrService, private fb: FormBuilder, private sharedService: SharedService, private regionService: RegionService) {
    this.regionForm = this.fb.group({
      country: ['', Validators.required],
      zone: ['', Validators.required],
      state: ['', Validators.required],
      regionName: ['', Validators.required],
      regionCode: [''],
      status: ['', Validators.required]
    });
  }

  public isCreate: boolean = false;
  public isEdit: boolean = false;
  public submitted: boolean = false;

  ngOnInit() {
    this.getList();
    this.getCountryList();
    this.searchInput.valueChanges.subscribe(() => {
      this.applyFilter();
    });
  }

  get f() { return this.regionForm.controls; }

  add() {
    this.isCreate = true;
  }

  selectedObject: any = {}
  editData(object: any) {
    this.isEdit = true;
    this.selectedObject = object;
    this.getZoneList(object?.state?.country?.id)
    this.getStateList(object?.state?.zone?.id)
    this.regionForm.patchValue({
      country: object?.state?.country?.id,
      zone: object?.state?.zone?.id,
      state: object?.state?.id,
      regionName: object.region_name,
      regionCode: object?.region_code,
      status: object.status ? 1 : 0
    })
  }

  back() {
    this.clearForm();
    this.selectedObject = {};
    this.isCreate = false;
    this.isEdit = false;
    this.getList();
  }
  applyFilter() {
    const filterValue = this.searchInput.value ? this.searchInput.value.trim().toLowerCase() : '';
  
    this.dataSource.filterPredicate = (data: any, filter: string) => {
      const region = data.region_name.toLowerCase().includes(filter);
      const regionCodeMatch = data.region_code.toLowerCase().includes(filter);

      return region || regionCodeMatch;
    };
      this.dataSource.filter = filterValue;
  }

  clearSearch() {
    this.searchInput.setValue('');
    this.applyFilter();
  }

  create() {
    this.submitted = true
    if (this.regionForm.valid) {
      const regionData = this.regionForm.value;
      let obj = {
        "state_id": regionData.state,
        "region_name": regionData.regionName,
        "region_code": regionData.regionCode,
        "status": parseInt(regionData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.regionService.createRegion(obj).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Region created successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  update() {
    this.submitted = true
    if (this.regionForm.valid) {
      const regionData = this.regionForm.value;
      let obj = {
        "state_id": parseInt(regionData.state),
        "region_name": regionData.regionName,
        "region_code": regionData.regionCode,
        "status": parseInt(regionData.status)
      }
      this.isLoading = new BehaviorSubject<boolean>(true);
      this.regionService.updateRegion(obj, this.selectedObject.id).subscribe((response: any) => {
        let responseData = response.body;
        if (responseData.responseCode == 200) {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.success("Region updated successfully!")
          this.back();
        } else {
          this.isLoading = new BehaviorSubject<boolean>(false);
          this.toastr.error(responseData.responseMessage)
        }
      }, (err: any) => {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.toastr.error(err)
      });
    }
  }

  clearForm() {
    this.submitted = false;
    this.regionForm.patchValue({
      state: '',
      country: '',
      zone: '',
      regionName: '',
      regionCode: '',
      status: ''
    });
    this.zoneList = [];
    this.stateList = [];
  }

  allowNumbersHyphenOnly(event: any) {
    var inp = String.fromCharCode(event.keyCode);
    if (/[0-9\-]/.test(inp)) {
      return true;
    } else {
      event.preventDefault();
      return false;
    }
  }

  getList() {
    this.isLoading = new BehaviorSubject<boolean>(true);
    this.regionService.getRegion().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.isLoading = new BehaviorSubject<boolean>(false);
        this.ELEMENT_DATA = responseData.data        
        this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        this.dataSource.sort = this.sort;
        this.dataSource.paginator = this.paginator;
      } else {
        this.isLoading = new BehaviorSubject<boolean>(false);
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  countryList: any = []
  getCountryList() {
    this.regionService.getCountry().subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.countryList = responseData.data
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  zoneList: any = []
  getZoneList(countryId?: any) {
    this.zoneList = []
    let id: any = this.regionForm.value.country ? this.regionForm.value.country : countryId
    this.regionService.getZoneByCountry(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.zoneList = responseData.data
        // this.regionForm.patchValue({
        //   zone: this.selectedObject.zone.id
        // });
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

  stateList: any = []
  getStateList(zoneId?: any) {
    this.regionForm.patchValue({state:''})
    this.stateList = []
    let id: any = this.regionForm.value.zone ? this.regionForm.value.zone : zoneId;
    this.regionService.getStateByZone(id).subscribe((response: any) => {
      let responseData = response.body
      if (responseData.responseCode == 200) {
        this.stateList = responseData.data
        this.regionForm.patchValue({
          state: this.selectedObject.state.id
        });
      }
    }, (err: any) => {
      this.isLoading = new BehaviorSubject<boolean>(false);
    });
  }

}
